// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

import App from './App'
import router from './router'

//these are the defaults
import Header from './components/Header'
import Footer from './components/Footer'
import Copyright from './components/Copyright'

Vue.config.productionTip = false;
Vue.use(VueAnalytics, {
	id: 'UA-103145457-1',
	router
})
//event goes here

Vue.component('app-header', Header)
Vue.component('app-footer', Footer)
Vue.component('app-copyright', Copyright)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },

})



// WEBPACK FOOTER //
// ./src/main.js